import type { WorldState } from "../state";
import { queueRemoval } from "../world";

/**
 * legacy: ExpirationStrategy. Counts down projectile and pickup lifetimes, queues expired ones.
 * Lasers under the laser-range rule expire once they have flown their distance instead.
 */
export function applyExpiry(world: WorldState): void {
	for (const e of world.entities) {
		if (e.kind === "laser" && e.rangeLeft !== null && e.rangeLeft <= 0) {
			queueRemoval(world, e.id);
			continue;
		}
		const expires = e.kind === "laser" || e.kind === "missile" || e.kind === "pickup";
		if (expires && e.ticksLeft !== null) {
			e.ticksLeft--;
			if (e.ticksLeft === 0) queueRemoval(world, e.id);
		}
	}
}
